import { TableV3Filters } from 'common/table/components/TableV3';
import { SearchableCandidateFilterInput } from 'generated-graphql/types';
import { ApplicantsTableColumns } from '../tables/types/ApplicantsTable';
import {
  buildSearchableCandidateFilters,
  buildFullNameFilter,
  buildAtsApplicationSourceFilter,
  buildStatusFilter,
  buildOriginFilter
} from './buildSearchableCandidateFilters';

type GetApplicantsFiltersProps = {
  organizationId: string;
  filters: TableV3Filters<ApplicantsTableColumns>;
};

export const getApplicantsFilters = ({
  organizationId,
  filters
}: GetApplicantsFiltersProps): SearchableCandidateFilterInput => {
  return buildSearchableCandidateFilters<keyof ApplicantsTableColumns>({
    searchFields: filters.searchFields,
    filterValues: filters.filterValues,
    searchFieldHandlers: {
      applicantName: buildFullNameFilter,
      atsApplicationSource: buildAtsApplicationSourceFilter
    },
    filterValueHandlers: {
      status: buildStatusFilter,
      isAllRequirementsMet: (items, andConditions) => {
        andConditions.push({
          isAllRequirementsMet: { eq: items[0].value === 'true' }
        });
      },
      origin: buildOriginFilter
    },
    baseFilter: { organizationId: { eq: organizationId } }
  });
};
